var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3303 1.34922V13.3759C12.3303 13.8159 12.117 14.2159 11.757 14.4692L2.14364 21.2026C1.35698 21.7492 0.236978 21.3226 0.0636443 20.3759C-0.136356 19.2292 0.130311 17.8826 0.930311 16.4292L5.09031 8.94922L9.01031 1.89589C9.31698 1.34922 9.65031 0.869221 9.99698 0.455888C10.797 -0.477445 12.3303 0.122555 12.3303 1.34922Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.517 21.2026L14.9037 14.4692C14.5437 14.2159 14.3303 13.8159 14.3303 13.3759V1.34922C14.3303 0.122555 15.8637 -0.477445 16.6637 0.455888C17.0103 0.869221 17.3437 1.34922 17.6503 1.89589L21.5703 8.94922L25.7303 16.4292C26.5303 17.8826 26.797 19.2292 26.597 20.3759C26.4237 21.3226 25.3037 21.7492 24.517 21.2026Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34357 21.6691L12.5436 16.2024C12.9836 15.9091 13.7036 15.9091 14.1436 16.2024L22.3436 21.6691C24.5169 23.1224 24.1569 24.3091 21.5436 24.3091H5.13024C2.53024 24.2958 2.17024 23.1091 4.34357 21.6691Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/Service.945686158fab8367d33ad76e376d98a5.svg";
export { ForwardRef as ReactComponent };